import { useTranslation } from 'react-i18next';
import {
  StyledLangListContainer,
  StyledContainer,
  StyledToggler,
  StyledLangButton,
} from './styles';
import { useAppDispatch, useAppSelector } from 'store/store';
import { toggleLanguage } from 'store/slices/userSettings';
import { UserRepository } from 'repositories/UserRepository';

export const LocaleToggler = ({ top }: { top?: boolean }) => {
  const { i18n } = useTranslation();
  const { token } = useAppSelector((state) => state.auth);
  const dispatch = useAppDispatch();

  const changeLangHandler = (lang: string) => () => {
    dispatch(toggleLanguage(lang));
    const langMap = new Map();
    langMap.set('ru', 'RUSSIAN');
    langMap.set('en', 'ENGLISH');

    if (token) UserRepository.setUserLanguage({ language: langMap.get(lang) }, token);
  };

  const activeLang = i18n.language;
  const restLanguages = i18n.languages.filter((lg) => lg !== activeLang);

  return (
    <StyledToggler>
      <StyledContainer>
        <StyledLangListContainer className={`${top ? 'top' : ''}`}>
          {restLanguages.map((lg) => (
            <StyledLangButton key={lg} onClick={changeLangHandler(lg)} tabIndex={0}>
              {lg}
            </StyledLangButton>
          ))}
        </StyledLangListContainer>
        <StyledLangButton onClick={changeLangHandler(i18n.language)}>
          {i18n.language}
        </StyledLangButton>
      </StyledContainer>
    </StyledToggler>
  );
};
